import { createSelector } from 'reselect';
import shuffle from 'lodash/shuffle';

import { selectBonusOffersNotQualifiedAndActiveFormatted } from 'core/modules/BonusOffers/selectors';

export const selectPopularOffers = state => state.popularOffers;
export const selectPopularOffersConfig = createSelector(
  selectPopularOffers,
  popularOffers => popularOffers.config,
);

export const selectPopularOffersIsLoading = createSelector(
  selectPopularOffers,
  popularOffers => popularOffers.isLoading,
);

export const selectPopularOffersIsLoaded = createSelector(
  selectPopularOffers,
  popularOffers => popularOffers.isLoaded,
);

export const selectPopularOffersPlacements = createSelector(
  selectPopularOffers,
  popularOffers => popularOffers.offers,
);

export const selectPopularOffersPlacementsToDispay = createSelector(
  selectPopularOffersPlacements,
  selectPopularOffersPlacements => shuffle(selectPopularOffersPlacements).slice(0, 3),
);

// Bonus offers
export const selectBonusOffers = createSelector(
  [selectBonusOffersNotQualifiedAndActiveFormatted, selectPopularOffersConfig],
  (bonusOffersValidFormatted, popularOffersConfig) => {
    const { bonusOffersLimit } = popularOffersConfig;
    return bonusOffersLimit ? bonusOffersValidFormatted.slice(0, bonusOffersLimit) : bonusOffersValidFormatted;
  },
);
